import { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'Components/Atoms/Button/Button';
import AuthLayout from 'Components/Templates/AuthLayout/AuthLayout';
import { reactivateUsersMe } from 'Services/user';
import { useErrors } from 'Components/Organisms/ErrorsProvider';
import { useTranslation } from 'react-i18next';

const Reactivate = ({ onReactivate }) => {
    const { showUnknownError } = useErrors();
    const [isProcessing, setIsProcessing] = useState(false);

    const { t } = useTranslation('common');

    const reactivateUser = () => {
        if (isProcessing) return;

        setIsProcessing(true);

        reactivateUsersMe()
            .then((response) => onReactivate(response))
            .catch((errorResponse) => showUnknownError(errorResponse))
            .finally(() => setIsProcessing(false));
    };

    return (
        <AuthLayout variant="minimal" title={t('reactivate-title')} description={t('reactivate-description')}>
            <div className="text-center">
                <div>
                    <Button variant="primary" isBusy={isProcessing} onClick={reactivateUser}>
                        {t('reactivate-button')}
                    </Button>
                </div>
            </div>
        </AuthLayout>
    );
};

export default Reactivate;

Reactivate.propTypes = {
    onReactivate: PropTypes.func.isRequired,
};
